import { Stack, Typography } from '@mui/joy';
import { isString } from 'lodash';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Line } from 'core/components';
import { IInfoCardLine } from 'core/types';
import { renderHtmlMessage } from 'core/utils';
import { Level, Variant } from 'theme/enums';

import { TitleWrapper, Wrapper } from './style';

interface IProps {
  title?: string;
  titleLevel?: Level;
  items?: IInfoCardLine[];
  onEdit?: () => void;
  isEditable?: boolean;
  filterEmptyLines?: boolean;
  // Single-line truncate the row labels (default). Set false to let long labels wrap.
  truncateLabel?: boolean;
}

const InfoCardView = ({
  title,
  titleLevel = Level.TITLE_LG,
  items,
  onEdit,
  isEditable = false,
  filterEmptyLines = false,
  truncateLabel = true,
}: IProps) => {
  const { t } = useTranslation();

  const filteredItems = useMemo(() => {
    let filteredItems = items;

    if (filterEmptyLines) {
      filteredItems = filteredItems?.filter((line) => line.value != null);
    }

    return filteredItems.filter((line) => !line.hidden);
  }, [items, filterEmptyLines]);

  return (
    <Wrapper>
      {(title || isEditable) && (
        <TitleWrapper>
          {title && (
            <Typography level={titleLevel} component="div">
              {isString(title) ? renderHtmlMessage(title) : title}
            </Typography>
          )}

          {isEditable && (
            <Button text={t('buttonLabelEdit')} variant={Variant.PLAIN} onClick={onEdit} />
          )}
        </TitleWrapper>
      )}

      <Stack>
        {filteredItems.map((line, index) => (
          <Line
            key={index}
            hasBackground={index % 2 === 0}
            truncateLabel={truncateLabel}
            {...line}
          />
        ))}
      </Stack>
    </Wrapper>
  );
};

export default InfoCardView;
